import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class LoaderService {
    isLoading :boolean;
    private subject = new Subject<boolean>();
    show() {

        this.isLoading =true;

    }

    hide() {
        this.isLoading = false;

    }

    refreshNav() {
        this.subject.next(true);
    }

    refreshNavObs(): Observable<any> {
        return this.subject.asObservable();
    }
}


// WEBPACK FOOTER //
// ./src/app/loader.service.ts